import { normalizeMarketingRows, mergeMarketingRows } from './socialAnalyticsData.mjs';

const errorMessage = async (response) => {
  const body = await response.json().catch(() => ({}));
  return body?.error || `Analytics request failed (${response.status}).`;
};

const request = async (path, { accessToken, method = 'GET', body } = {}) => {
  const response = await fetch(path, {
    method,
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(body ? { 'Content-Type': 'application/json' } : {})
    },
    body: body ? JSON.stringify(body) : undefined
  });
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json();
};

const path = (route, dashboardId = 'vasia') => `/api/social-analytics/${route}?dashboardId=${encodeURIComponent(dashboardId)}`;

export const getSocialAnalyticsConfig = ({ accessToken, dashboardId }) => request(path('config', dashboardId), { accessToken });
export const listSocialConnections = ({ accessToken, dashboardId }) => request(path('connections', dashboardId), { accessToken });
export const connectSocialProvider = ({ accessToken, dashboardId, connection }) => request(path('connect', dashboardId), {
  accessToken,
  method: 'POST',
  body: connection
});
export const disconnectSocialProvider = ({ accessToken, dashboardId, platform, connectionId }) => request(path('disconnect', dashboardId), {
  accessToken,
  method: 'POST',
  body: { platform, connectionId }
});
export const syncSocialAnalytics = ({ accessToken, dashboardId, platform, connectionId }) => request(path('sync', dashboardId), {
  accessToken,
  method: 'POST',
  body: platform || connectionId ? { platform, connectionId } : {}
});
export const getSocialAnalyticsData = ({ accessToken, dashboardId }) => request(path('data', dashboardId), { accessToken });
export const getActiveAccounts = ({ accessToken, dashboardId }) => request(path('active-accounts', dashboardId), { accessToken });
export const saveActiveAccounts = ({ accessToken, dashboardId, accounts }) => request(path('active-accounts', dashboardId), {
  accessToken,
  method: 'PUT',
  body: { accounts }
});

export const loadMergedMarketingData = async ({ accessToken, dashboardId = 'vasia', historicalRows = [] }) => {
  const payload = await getSocialAnalyticsData({ accessToken, dashboardId });
  const liveRows = normalizeMarketingRows(payload.rows || []);
  return {
    rows: mergeMarketingRows(historicalRows, liveRows),
    liveRows,
    source: payload.source || 'supabase_marketing_analytics'
  };
};
